export default "__VITE_ASSET__aSVuLluZ__"